import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import DocsNavLink from "./DocsNavLink";
import sidebarStyles from "../../styles/docs/docsSidebar.module.scss";

const DocsNavGroup = ({ group, activeId, onNavigate, defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);
  const Icon = group.icon;
  const isActive = group.items.some((i) => i.id === activeId);

  return (
    <div className={sidebarStyles.navGroup}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className={`${sidebarStyles.navGroupToggle} ${isActive ? sidebarStyles.navGroupToggleActive : ""}`}
      >
        <div className={sidebarStyles.navGroupToggleInner}>
          <Icon size={15} />
          <span className={sidebarStyles.navGroupLabel}>{group.label}</span>
        </div>
        <ChevronDown
          size={13}
          className={`${sidebarStyles.navGroupChevron} ${open ? sidebarStyles.navGroupChevronOpen : ""}`}
        />
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.18, ease: "easeInOut" }}
            className={sidebarStyles.navGroupItems}
            style={{ overflow: "hidden" }}
          >
            {group.items.map((item) => (
              <DocsNavLink
                key={item.id}
                route={item.route}
                label={item.label}
                onNavigate={onNavigate}
              />
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DocsNavGroup;
